var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MazPhoneNumberInput',{attrs:{"default-country-code":_vm.defaultCountryCode,"translations":{
            countrySelectorLabel: _vm.countrySelectorLabel,
            countrySelectorError: _vm.countrySelectorError,
            phoneNumberLabel: _vm.phoneNumberLabel,
            example: _vm.example
        }},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}}),_c('button',{staticClass:"select",style:({ background: _vm.theme }),attrs:{"disabled":!_vm.phoneNumber},on:{"click":_vm.select}},[_vm._v("\n        OK\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }